var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "address-autocomplete",
      class:
        _vm.isActive || _vm.searchKey || _vm.autoCompleteText
          ? "is-active"
          : "",
    },
    [
      _c(
        "form-group",
        { attrs: { name: "address", label: _vm.label } },
        [
          _c("md-input", {
            attrs: { name: "address", type: "hidden" },
            model: {
              value: _vm.autoCompleteText,
              callback: function ($$v) {
                _vm.autoCompleteText = $$v
              },
              expression: "autoCompleteText",
            },
          }),
          _c("vue-select", {
            staticClass: "address-select",
            attrs: {
              label: _vm.label,
              id: _vm.id,
              options: _vm.addressOptions,
              reduce: function (option) {
                return option.value
              },
              filterable: false,
              loading: _vm.searchStatus === "searching",
            },
            on: {
              search: _vm.handleSearch,
              "search:blur": _vm.handleBlur,
              "search:focus": _vm.handleFocus,
              input: _vm.handleInput,
            },
            scopedSlots: _vm._u([
              {
                key: "search",
                fn: function (ref) {
                  var attributes = ref.attributes
                  var events = ref.events
                  return [
                    _c(
                      "input",
                      _vm._g(
                        _vm._b(
                          {
                            staticClass: "vs__search",
                            staticStyle: {
                              "margin-left": "-7px",
                              "font-size": "0.8rem",
                            },
                            attrs: { type: "search" },
                          },
                          "input",
                          Object.assign({}, attributes, {
                            autocomplete: _vm.autoCompleteText,
                            value: _vm.searchKey,
                          }),
                          false
                        ),
                        events
                      )
                    ),
                  ]
                },
              },
              {
                key: "option",
                fn: function (option) {
                  return [
                    _c(
                      "div",
                      {
                        staticClass: "address-option",
                        class: _vm.getClass(option),
                      },
                      [
                        option.level === 0
                          ? [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(option.label) +
                                  "\n                    "
                              ),
                            ]
                          : [
                              option.icon
                                ? _c(
                                    "div",
                                    { staticClass: "option-icon--container" },
                                    [
                                      _c("img", {
                                        staticClass: "option-icon",
                                        attrs: {
                                          src: option.icon,
                                          alt: "Location Icon",
                                        },
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                              _c("HighlightedAddressText", {
                                attrs: {
                                  highlights: option.highlightInfo,
                                  text: option.label,
                                },
                              }),
                            ],
                      ],
                      2
                    ),
                  ]
                },
              },
              {
                key: "no-options",
                fn: function () {
                  return [
                    _vm.searchStatus === "searching"
                      ? [_c("em", [_vm._v("Searching")])]
                      : _vm._e(),
                    _vm.searchStatus === "idle"
                      ? [_c("em", [_vm._v("Type an address to search")])]
                      : _vm._e(),
                    _vm.searchStatus === "done"
                      ? [_c("em", [_vm._v("No results found")])]
                      : _vm._e(),
                  ]
                },
                proxy: true,
              },
            ]),
            model: {
              value: _vm.selectedOption,
              callback: function ($$v) {
                _vm.selectedOption = $$v
              },
              expression: "selectedOption",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }